import { Line, mixins } from 'vue-chartjs'
const  { reactiveProp } = mixins
export default{
    props:['chartdata','options'],
    extends: Line,
    // mounted(){
    //     this.renderChart(this.chartdata, this.options)
    // },
    watch: {
        chartdata(){
            console.log(this.chartdata);
            this.renderChart(this.chartdata, this.options)
        }
    }
}